import * as React from "react";
const SvgFiBrandsFirefox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-firefox_svg__a)">
      <path
        fill="#151A2D"
        d="M14.497 15.012c1.528 0 3.037-.904 4.001-2.051 1.354-1.61 1.513-4.004.92-5.953a7.1 7.1 0 0 0-.75-1.666 8 8 0 0 0-1.3-1.587C15.066 1.553 11.76.627 8.66 1.192c-1.05.19-2.112.534-3.03 1.085l-.013.008.004-.003-.006.003-.007.006.004-.004-.004.004C6.556 1.37 8.055.634 9.76.275a11.8 11.8 0 0 1 2.451-.246c1.797 0 3.587.44 5.201 1.224a10.8 10.8 0 0 1 3.04 2.19 13.3 13.3 0 0 1 1.811 2.305 11.8 11.8 0 0 1 1.328 3.09l.002.008c.265.99.407 2.034.407 3.109 0 6.636-5.38 12.016-12.016 12.016-5.943 0-10.878-4.315-11.844-9.983-.026-.153-.037-.31-.055-.464q-.082-.71-.085-1.428c-.006-1.607.284-3.213.864-4.61a8 8 0 0 1 1.59-2.398c.28-.284.561-.508.821-.642q-.075.148-.147.298a13 13 0 0 0-.705 1.807A9.5 9.5 0 0 0 2.027 8.5c.132-.434.295-.86.49-1.27l.08-.164a8.3 8.3 0 0 1 1.63-2.236c.333-.32.693-.615 1.078-.874 1.42-.955 3.08-1.37 4.472-1.33 1.01.029 1.882.295 2.422.766l-.116.04q-.059.021-.116.046c-2.4.97-4.906 4.289-4.33 8.16.105.717.31 1.31.588 1.895-.458-1.212-.499-2.922.242-4.028.827-1.233 2.014-1.5 2.646-1.363-1.903 1.618-1.51 4.963 1.12 6.306a5.1 5.1 0 0 0 2.264.564"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-firefox_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsFirefox;
